import { ReactElement, useEffect, useState } from "react";
import LayoutCard from "../shared-ui-components/LayoutCard";
import "./IndicatorsOverviewsLayoutCard.scss";
import { BarChartOutlined } from "@ant-design/icons";
import { ServerCategorizationsData } from "../models/data-structures";
import { extractOverviewCardsPropsFromServerData } from "../logic/data-processing";
import {
  IndicatorOverviewsInnerCard,
  IndicatorOverviewsInnerCardProps,
} from "./IndicatorOverviewsInnerCard";

export default function IndicatorsOverviewsLayoutCard({
  data,
}: {
  data: ServerCategorizationsData;
}): ReactElement {
  const fileAnalysisData = data;
  const [overviewsCardsProps, setOverviewsCardsProps] = useState<
    IndicatorOverviewsInnerCardProps[]
  >([]);

  useEffect(() => {
    setOverviewsCardsProps(
      extractOverviewCardsPropsFromServerData(fileAnalysisData),
    );
  }, [fileAnalysisData]);

  return (
    <LayoutCard className="main">
      {{
        header: (
          <div className="layout-card-header-text flex-row-with-vertical-alignment">
            <BarChartOutlined className="icon-with-background" />
            Indicators Overview
            {/* <ToolTip
              children={`$<ExclamationCircleOutlined className="exclamation-circle" />`}
              content="Please contact us about scanning larger files"
            /> */}
          </div>
        ),
        content: (
          <div className="indicators-grid">
            {overviewsCardsProps.length > 0 ? (
              overviewsCardsProps.map((cardData) => (
                <IndicatorOverviewsInnerCard
                  className="full-width"
                  key={cardData.category}
                  {...cardData}
                ></IndicatorOverviewsInnerCard>
              ))
            ) : (
              <h2 className="flex-justify-center">
                No risk indicators have been detected in this file
              </h2>
            )}
          </div>
        ),
      }}
    </LayoutCard>
  );
}
